import { ReactElement } from 'react'
import { styled } from '@mui/material'
import { usePanelHistoryTop } from 'weblite-router'
import { useIsDesktopSize } from '$common/react-hooks/layout'
import { ChatBG } from '$comp/_app/components/chat/components/chat-bg'
import { BG_GRADIANT } from '$setup/style/constants'

const Container = styled('div')`
  width: 100%;
  height: 100%;
  position: relative;

  background: ${({ theme }) => theme.palette.primary500};
  transition: background 300ms;

  display: flex;
  align-items: center;
  justify-content: center;

  &[data-lighten-bg='true'] {
    background: ${BG_GRADIANT};
  }
`

const BGPattern = styled(ChatBG)`
  transition: opacity 300ms;

  &[data-hidden='true'] {
    opacity: 0;
  }
`

const DesktopBody = styled('div')`
  width: 400px;
  border-radius: 24px;
  max-height: calc(100% - 80px);
  box-shadow: ${({ theme }) => theme.shadows[2]};
  background-color: ${({ theme }) => theme.palette.neutral000};
  overflow: hidden;
  z-index: 1;
  overflow-y: auto;

  @keyframes scale-in {
    from {
      opacity: 0;
      transform: scale(0.5);
    }

    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  animation: scale-in 500ms;
`

interface PropTypes {
  children: ReactElement
}
export function AuthContainer({ children }: PropTypes) {
  const isDesktop = useIsDesktopSize()
  const topLocation = usePanelHistoryTop('root')?.location

  const renderedSlider = topLocation === 'root/auth/slider'

  return isDesktop ? (
    <Container data-lighten-bg={!renderedSlider}>
      <BGPattern data-hidden={renderedSlider} />
      <DesktopBody>{children}</DesktopBody>
    </Container>
  ) : (
    children!
  )
}
